module.exports = __webpack_public_path__ + "static/media/add payroll.3d878688.svg";